import styled from 'styled-components'
import { sizes, colors } from '../../util'

export const Wrap = styled.div`
  height: 100vh;
  margin: 0 6rem;
  position: relative;
`

export const Title = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 0.5rem 1.5rem;
  background: white;
  transform: translateY(100%);
  transition: 0.33s;
`

export const RelativeWrapper = styled.div`
  position: relative;
  overflow: hidden;
  &:hover {
    ${Title} {
      transform: translateY(0%);
    }
  }
`

export const ImageTest = styled.img`
  /* max-height: 400px;
  @media (min-width: ${sizes.medium}) {
    max-height: 600px;
  } */
  /* width: 50vw; */
  height: ${({ ar }) => `calc(45vw / ${ar})`};
  width: 100%;
  object-fit: contain;
  max-height: 75vh;
  /* max-width: 70vw; */
  /* height: 80vh; */
  /* margin: 0 2rem; */

`

export const Placeholder = styled.div`
  max-height: 100vh;
  width: ${({ ar }) => `calc(100vh * ${ar})`};
  height: 100vh;
  object-fit: contain;
  display: flex;
  align-items: center;
  div {
    width: 100%;
    height: 0;
    padding-bottom: ${({ arp }) => `${arp}%`};
    background: green;
  }
  max-width: 100%;
`

export const PlaceholderWrapper = styled.div`
  opacity: ${props => (props.loading ? 1 : 0)};
  transition: opacity 0.5s;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  div {
    height: 100%;
    width: 66%;
    background: #eee;
    &:nth-child(even) {
      height: 300%;
      width: 100%;
      margin: 3rem 0;
    }
  }
  position: absolute;
`

export const SliderWrapper = styled.div`
  opacity: ${props => (props.loading ? 0 : 1)};
  transition: opacity 0.5s;
  width: 100%;
  /* position: relative; */
  .swiper-wrapper {
    align-items: center;
    height: 100vh;
  }
  .swiper-slide {
    /* flex-shrink: 1;
    flex-grow: 1; */
    /* height: 100%; */
    height: auto;
    max-height: 75vh;
  }
`
export const Loading = styled.p`
  opacity: ${props => (props.loading ? 1 : 0)};
  transition: opacity 2s;
  position: absolute;
  left: 50%;
  top: 50%;
  height: initial !important;
  min-height: initial !important;
  color: ${props => props.theme.colorText};
  z-index: 2;
`
